"use strict";

exports.__esModule = true;
exports.default = createHistory;

var _redux = require("redux");

var _Actions = _interopRequireDefault(require("./Actions"));

var _createHistoryEnhancer = _interopRequireDefault(require("./createHistoryEnhancer"));

var _createStoreHistory = _interopRequireDefault(require("./createStoreHistory"));

var _locationReducer = _interopRequireDefault(require("./locationReducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createHistory(options) {
  var store = (0, _redux.createStore)(_locationReducer.default, (0, _createHistoryEnhancer.default)(options));
  store.dispatch(_Actions.default.init());
  return (0, _createStoreHistory.default)(store, function (location) {
    return location;
  });
}

module.exports = exports.default;